import { mainUrl } from "../../../api/apiSettings";

// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/mural
// POST - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/mural

// POST - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/mural/comment/{postId}/{muralType}
// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/mural/comment/{postId}
export const MURAL_GET = `${mainUrl}/mural`;
export const MURAL_POST = `${mainUrl}/mural`;

// DELETE - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/mural/{postId}/{commentId}
export const MURAL_DELETE = (postId, commentId) => `${mainUrl}/mural/${postId}/${commentId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/like/add
export const POST_ADD_LIKE = `${mainUrl}/mural/like/add`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/like/remove
export const POST_REMOVE_LIKE = `${mainUrl}/mural/like/remove/`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/like/{postId}/{userId}
export const GET_CHECK_LIKE = (uniqueId, userId) => `${mainUrl}/mural/like/${uniqueId}/${userId}`;

// POST - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/comment
export const COMMENT_POST = `${mainUrl}/mural/comment`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/comment/{postId}
export const COMMENT_GET = (postId) => `${mainUrl}/mural/comment/${postId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/mural/image/{postId}
export const MURAL_GET_IMAGE = (postId) => `${mainUrl}/mural/image/${postId}`;
